<div class="info-background">
  <slotcom-navigation-button
    type="close"
    (click)="closeInfo()" />

  <slotcom-p
    class="info-title"
    [bold]="true"
    [text]="'home.progress-line.casino-info.title' | translate"
    [shadowBorder]="true" />

  <div class="info-steps-container">
    @for (step of steps; track step.asset; let last = $last) {
      <div class="info-step">
        <div
          class="step-image"
          theming
          themingGroup="progressline"
          [themingAsset]="step.asset"></div>

        <slotcom-p
          class="step-label"
          [bold]="true"
          [text]="step.label | translate"
          [shadowBorder]="true"></slotcom-p>
      </div>

      @if (!last) {
        <div
          theming
          themingGroup="progressline"
          themingAsset="arrow"
          class="arrow-img"></div>
      }
    }
  </div>
</div>
